import { ApolloClient } from "@apollo/client";
import { MasterDataGraphQlAdapter } from "@src/infrastructure/adapters/graphQl/MasterDataGraphQlAdapter";
import { GET_PROMO_TYPES_LOOKUP } from "@src/domain/graphql/masterData";
import type {
  PromoTypeLookupItem,
  PromoTypesLookupResponse,
} from "@src/domain/dto/masterData";
import type { IMasterDataPromoTypesLookupRepository } from "@src/domain/repositories/masterData";
import { throwIfMasterDataGraphQLError } from "./masterDataRepository.shared";

export class MasterDataPromoTypesLookupRepository
  implements IMasterDataPromoTypesLookupRepository
{
  private readonly client: ApolloClient;

  constructor(
    client: ApolloClient = MasterDataGraphQlAdapter.getInstance().getClient(),
  ) {
    this.client = client;
  }

  async getPromoTypesLookup(): Promise<{
    items: PromoTypeLookupItem[];
    count: number;
  }> {
    const { data, error } = await this.client.query<PromoTypesLookupResponse>({
      query: GET_PROMO_TYPES_LOOKUP,
      fetchPolicy: "network-only",
      errorPolicy: "all",
    });

    throwIfMasterDataGraphQLError({ error });

    const response = data?.promoTypesLookup;
    if (!response) {
      throw new Error("Failed to fetch promo types lookup");
    }

    return {
      items: (response.items ?? []).flatMap((item) => {
        if (item.promoTypeId == null) return [];
        return [
          {
            promoTypeId: item.promoTypeId,
            promoTypeName: item.promoTypeName ?? "",
            promoTypeCode: item.promoTypeCode ?? null,
            promoTypeKey: item.promoTypeKey ?? null,
          },
        ];
      }),
      count: response.count ?? 0,
    };
  }
}
